module.exports = __webpack_public_path__ + "img/float.56acb9af.png";